export default {
  methods: {
    getActiveClass(item) {
      return ''
    },
    rowClass(item) {
      const activeClass = this.getActiveClass(item)

      if (item.deleted) {
        return `row-deleted ${activeClass}`
      }
      if (item.new) {
        return `row-new ${activeClass}`
      }
      if (item.edited) {
        return `row-edited ${activeClass}`
      }
      if (item.not_seen) {
        return `row-not-seen ${activeClass}`
      }
      return `${activeClass}`
    },
  },
}
